// extracted by mini-css-extract-plugin
export default {"location_wrapper":"styles_location_wrapper__XI2pE","time_left":"styles_time_left__eR1Jg"};